/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfWatchlistV1OfacSdnState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_WATCHLIST_V1_OFAC_SDN_STATE_ENTITY_NAME = 'ixf.watchlist.v1.OfacSdn';
export const ixfWatchlistV1OfacSdnStateEntity = new schema.Entity<IxfWatchlistV1OfacSdnState>(IXF_WATCHLIST_V1_OFAC_SDN_STATE_ENTITY_NAME, {}, { idAttribute: 'ofacSdnId' });

